'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactGoogleMaps = require('react-google-maps');

var _selectors = require('./selectors');

var _Marker = require('./Marker');

var _Marker2 = _interopRequireDefault(_Marker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'location-map';

var extendPoint = function extendPoint(bounds, amount) {
  bounds.extend(new google.maps.LatLng(bounds.getNorthEast().lat() + amount, bounds.getNorthEast().lng() + amount));
};

var mapStateToProps = function mapStateToProps(state, _ref) {
  var locations = _ref.locations;
  return {
    locations: (0, _selectors.selectLatLngForLocations)(state, locations)
  };
};

var getValidLocations = function getValidLocations() {
  var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return locations.filter(function (location) {
    return location.position;
  });
};

var GoogleMapComponent = function (_Component) {
  (0, _inherits3.default)(GoogleMapComponent, _Component);

  function GoogleMapComponent(props) {
    (0, _classCallCheck3.default)(this, GoogleMapComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleMapComponent.__proto__ || (0, _getPrototypeOf2.default)(GoogleMapComponent)).call(this, props));

    _this.handleRef = _this.handleRef.bind(_this);
    _this.getMarkers = _this.getMarkers.bind(_this);
    _this.clickMarker = _this.clickMarker.bind(_this);
    _this.centered = false;
    _this.state = {
      currentMarker: null
    };
    _this.markerInterval = null;
    return _this;
  }

  (0, _createClass3.default)(GoogleMapComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.markerInterval = setInterval(function () {
        _this2.forceUpdate();
      }, 100);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.map && !this.centered) {
        this.centerMap();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.markerInterval);
    }
  }, {
    key: 'getMarkers',
    value: function getMarkers() {
      var _this3 = this;

      if (!this.map) {
        return null;
      }

      clearInterval(this.markerInterval);

      var locations = getValidLocations(this.props.locations);
      return locations.map(function (location, index) {
        var title = location.title,
            _location$address = location.address,
            line1 = _location$address.line1,
            line2 = _location$address.line2,
            city = _location$address.city,
            state = _location$address.state,
            zip = _location$address.zip,
            phone = _location$address.phone,
            email = _location$address.email,
            _location$position = location.position,
            lat = _location$position.lat,
            lng = _location$position.lng;


        var content = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            title
          ),
          _react2.default.createElement(
            'p',
            null,
            line1
          ),
          line2 ? _react2.default.createElement(
            'p',
            null,
            line2
          ) : null,
          _react2.default.createElement(
            'p',
            null,
            city,
            ', ',
            state,
            ' ',
            zip
          ),
          phone ? _react2.default.createElement(
            'p',
            null,
            phone
          ) : null,
          email ? _react2.default.createElement(
            'p',
            null,
            email
          ) : null
        );

        return _react2.default.createElement(
          _Marker2.default,
          {
            key: index,
            lat: lat,
            lng: lng,
            mapHolderRef: _this3.map,
            showContent: index === _this3.state.currentMarker,
            label: '' + (index + 1),
            handleClick: function handleClick() {
              _this3.clickMarker(index);
            }
          },
          content
        );
      });
    }
  }, {
    key: 'clickMarker',
    value: function clickMarker(index) {
      this.setState({
        currentMarker: index
      });
    }
  }, {
    key: 'centerMap',
    value: function centerMap() {
      var locations = getValidLocations(this.props.locations);
      if (locations.length) {
        var bounds = locations.map(function (location) {
          return location.position;
        }).reduce(function (boundObj, _ref2) {
          var lat = _ref2.lat,
              lng = _ref2.lng;

          return boundObj.extend(new google.maps.LatLng(lat, lng));
        }, new google.maps.LatLngBounds());

        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
          extendPoint(bounds, 0.01);
          extendPoint(bounds, -0.01);
        }
        this.centered = true;
        this.map.fitBounds(bounds);
      }
    }
  }, {
    key: 'handleRef',
    value: function handleRef(map) {
      if (map && !this.map && !this.centered) {
        this.map = map;
        this.centerMap();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var containerElement = _react2.default.createElement('div', {
        style: {
          height: '300px',
          width: '300px'
        }
      });
      var googleMapElement = _react2.default.createElement(
        _reactGoogleMaps.GoogleMap,
        {
          ref: this.handleRef,
          defaultZoom: 6,
          defaultCenter: {
            lat: 40.7239173,
            lng: -74.0587175
          }
        },
        this.getMarkers()
      );
      return _react2.default.createElement(
        'div',
        { className: CLASS_NAME },
        _react2.default.createElement(_reactGoogleMaps.GoogleMapLoader, {
          containerElement: containerElement,
          googleMapElement: googleMapElement
        })
      );
    }
  }]);
  return GoogleMapComponent;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(mapStateToProps)(GoogleMapComponent);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Locations/GoogleMap.jsx
// module id = 1217
// module chunks = 0